function Loading() {
  return (
    <>
      {" "}
      <div className="w-full h-screen flex items-center justify-center">
        <div className="text-3xl text-white font-semibold">Loading...</div>
      </div>
    </>
  );
}

export default Loading;
